import { useMutation } from '@tanstack/react-query'
import {
  bulkLocationCreate,
  BulkLocationCreateData,
  BulkLocationCreateResponse,
  BulkLocationCreateErrorResponse,
} from 'api/shifts'

export const useBulkLocationCreateMutation = () => {
  return useMutation<
    BulkLocationCreateResponse,
    BulkLocationCreateErrorResponse,
    BulkLocationCreateData
  >({
    mutationFn: bulkLocationCreate,
  })
}
